import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import EventStatusIcon from 'app/frontend/base/components/EventStatusIcon'
import { useTranslation } from 'react-i18next'

type Props = {
  currentStatus: wowaudit.EventParticipantReference['status']
  statuses: wowaudit.EventParticipantReference['status'][]
  onSelect: (nextStatus: wowaudit.EventParticipantReference['status']) => void
}

const EventParticipantStatusItems = ({
  currentStatus,
  statuses,
  onSelect,
}: Props) => {
  const { t } = useTranslation()

  return (
    <>
      {statuses.map((nextStatus) => (
        <DropdownMenuItem
          key={nextStatus}
          className={cn(
            'flex items-center gap-2',
            nextStatus === currentStatus && 'bg-accent',
          )}
          onClick={() => onSelect(nextStatus)}
        >
          <EventStatusIcon status={nextStatus} size='small' />
          <span className='text-xs'>
            {t(`settings.raidsAvailableStatuses.options.${nextStatus}`)}
          </span>
        </DropdownMenuItem>
      ))}
    </>
  )
}

export default EventParticipantStatusItems
